import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";

export const useGetMessageReactions = (messageId: string, enabled: boolean = false) => {
  return useQuery({
    queryKey: ["reactions", "message", messageId],
    queryFn: () =>
      chatApi.getMessageReactions({
        messageId,
        pageIndex: 1,
        pageSize: 50,
      }),
    enabled: enabled && !!messageId,
  });
};
